export const normalizeWs = (value: string) => value.replace(/\s+/g, ' ');
